import mixpanel from 'mixpanel-browser';
import { matchPath } from 'react-router-dom';

// UTILS
import { invertObjectKeysAndValues } from 'utils';

// CONSTANTS
import { FLEET_PLANS } from 'constants/plans';
import { ANALYTICS_EVENTS, DEALERSHIP_NAME_GROUP_KEY, ROUTE_PATTERNS } from 'constants/mixpanel.constants';

// Gets the route pattern for a given pathname (e.g. /fleet/vehicles/123 -> /fleet/vehicles/:id)
export const getRoutePattern = (pathname: string): string =>
  ROUTE_PATTERNS.find((pattern) => matchPath(pathname, { path: pattern, exact: true })) ?? pathname;

// Tracks a page view as the user navigates around the app. Overriding 'referrer' to grab the original ref URL.
export const trackPageView = (location: { pathname: string; search: string }, referrer?: string) => {
  const referrerUrl = referrer ? `${window.location.origin}${referrer}` : undefined;

  mixpanel.track(ANALYTICS_EVENTS.PAGE_VIEW, {
    path: location.pathname,
    route: getRoutePattern(location.pathname),
    search: location.search,
    url: `${location.pathname}${location.search}`,
    ...(referrerUrl && { Referrer: referrerUrl, $referrer: referrerUrl }),
  });
};

export const identifyAndAssign = (userResponse) => {
  mixpanel.identify(userResponse.email);
  mixpanel.set_group(DEALERSHIP_NAME_GROUP_KEY, userResponse.profile.dealership.name);
  mixpanel.people.set({
    $name: `${userResponse.firstName} ${userResponse.lastName}`,
    $email: userResponse.email,
    Dealership: userResponse.profile.dealership.name,
    Role: userResponse.profile.role,
    Department: userResponse.profile.department,
    Language: userResponse.profile.language,
  });

  // Extract Plans bases on their value and get the name.
  const plans = invertObjectKeysAndValues(FLEET_PLANS);

  // Add profile to group if it doesn't exist already, set the group plan.
  mixpanel
    .get_group(DEALERSHIP_NAME_GROUP_KEY, userResponse.profile.dealership.name)
    .set('Plan', plans[userResponse.profile.dealership.settings.planId]);
};
